import { __decorate } from "tslib";
import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { AuthService } from '../../services/auth.service';
import { PaymentService } from '../../services/payment.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { ActivatedRoute } from '@angular/router';
/**
 * Dropdown Component
 */
let CountriesDropdownComponent = class CountriesDropdownComponent {
    constructor(httpClient, auth, paymentService, sanitizer, changeDetector, themeService, route) {
        this.httpClient = httpClient;
        this.auth = auth;
        this.paymentService = paymentService;
        this.sanitizer = sanitizer;
        this.changeDetector = changeDetector;
        this.themeService = themeService;
        this.route = route;
        this.borderRadiusSmaller = '';
        this.showCountry = false;
        this.inputBackColor = '';
        this.textColor = '';
        this.setCou = new EventEmitter();
        this.themeService.getTheme().subscribe((data) => {
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
        });
    }
    ngOnInit() {
    }
    clickCountry() {
        this.showCountry = !this.showCountry;
    }
    onDocumentClick(event) {
        const targetElement = event.target;
        if (targetElement.className !== 'currencySelected' &&
            targetElement.className !== 'currencySelectOptions' &&
            targetElement.className !== 'currencySelect') {
            this.closeCountry();
        }
    }
    closeCountry() {
        this.showCountry = false;
    }
    setCountry(id) {
        this.countryId = id;
        this.setCou.emit(id);
    }
};
CountriesDropdownComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: AuthService },
    { type: PaymentService },
    { type: DomSanitizer },
    { type: ChangeDetectorRef },
    { type: WebsiteThemeService },
    { type: ActivatedRoute }
];
__decorate([
    Input()
], CountriesDropdownComponent.prototype, "countries", void 0);
__decorate([
    Input()
], CountriesDropdownComponent.prototype, "countryId", void 0);
__decorate([
    Input()
], CountriesDropdownComponent.prototype, "formDesign", void 0);
__decorate([
    Output("setCou")
], CountriesDropdownComponent.prototype, "setCou", void 0);
__decorate([
    HostListener('document:click', ['$event'])
], CountriesDropdownComponent.prototype, "onDocumentClick", null);
CountriesDropdownComponent = __decorate([
    Component({
        selector: 'ecd-countries-dropdown',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./countries-dropdown.component.html")).default
    })
], CountriesDropdownComponent);
export { CountriesDropdownComponent };
